module.exports = __webpack_public_path__ + "img/cursor2.027fc995.png";